function manipulateInputFields() {
    var inputFields = document.querySelectorAll('input');
  
    // Loop through each input field
    inputFields.forEach(function(input) {
      // Check if the input field has the class 'stg_selected'
      if (input.classList.contains('stg_selected')) {
        // Do nothing if it contains the class 'stg_selected'
        return;
      }
  
      // Check if the input field has the class 'hulk_po_other_options'
      if (input.classList.contains('hulk_po_other_options')) {
        // Set its value to an empty string if it contains the class 'hulk_po_other_options'
        input.value = '';
      }
    });
  }
  
  document.querySelector('.edit_cart_option').addEventListener('click', function() {
    setTimeout(function() {
      manipulateInputFields();
    }, 2000); // 2 seconds delay
  });